import { Schema } from '@core/data/dto/schema';

export const EmployeeResidenceSchema = {
    address_line_1: Schema.String,
    address_line_2: Schema.String,
    city: Schema.String,
    state: Schema.String,
    postal_code: Schema.String,
    country: Schema.String
}